/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.getServiceAuth'

export { $nsid }

/** Get a signed token on behalf of the requesting DID for the requested service. */
const main = l.query(
  $nsid,
  l.params({
    aud: l.string({ format: 'did' }),
    exp: l.optional(l.integer()),
    lxm: l.optional(l.string({ format: 'nsid' })),
  }),
  l.jsonPayload({ token: l.string() }),
  ['BadExpiration'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
